<template>
    <div class="main-content">
        <div class="row orders_to_call_row">
            <div class="col-md-12">
<!--                <h5>Курьер</h5>-->
            </div>
            <div class="col-md-12">
                <pulse-loader :loading="loading" :color="color" class="text-center"/>
            </div>

            <div class="col-md-12 orders_to_call_div">
                <div class="card" v-if="orders">
                    <div class="card-body">
                        <CabinOrdersRunnerTable :orders="orders" :runner="runner" :mainTaskId="mainTaskId" :runnerTasksIncome="tasks"/>
                    </div>
                </div>
                <div class="card" v-else>
                    <div class="card-body">
                        <h5>{{errorMessage}}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    import api from '@/api'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import CabinOrdersRunnerTable from '@/views/components/runners/cabinOrdersRunnersTable'
    // import Ls from './ls'

    export default {
        components: {
            PulseLoader,
            CabinOrdersRunnerTable,
        },
        data() {
            return {
                loading: true,
                color: '#007dcc',
                runner: null,
                orders: null,
                errorMessage: null,
                tasks: null,
                mainTaskId: null,
            }
        },
        mounted() {
            this.getOrders();
        },
        methods: {
          async getOrders() {
              let {data} = await api.store('/runners/getRunnerOrders',{
                  imei: this.$route.query.imei || null,
              });

              if (!data.success){
                  this.errorMessage = data.message || 'Задач не найдено';
              }else {
                  if (data.api_token) {
                      localStorage.setItem('api-token', data.api_token);
                      console.log(data.api_token);
                  }
                    // this.$ls.set('api-token', data.api_token);
                    // Ls.set('api-token', data.api_token);

                  this.orders = data.orders;
                  this.runner = data.runner;
                  this.tasks = data.tasks;
                  this.mainTaskId = data.mainTaskId;
              }
              this.loading = false;
          }
        }
    }

</script>
